import { PageContainer, SpinnerCenter } from "@shapr3d/frontend-lib";
import { useParams } from "react-router-dom";

import { useGuardSyncOffTeams } from "../../hooks/useGuardSyncOffTeams";
import { useProjects } from "../../hooks/useProject";
import useTranslation from "../../hooks/useTranslation";
import { OverlayProvider } from "../Headers/components/ShareModal/components/MenuPortal";
import { ProjectList } from "../ProjectList/ProjectList";
import { WelcomeModal } from "../WelcomeModal/WelcomeModal";

export const SharedWithMe = () => {
  useGuardSyncOffTeams();
  const { t, m } = useTranslation();

  const { teamID } = useParams();
  const { data, isLoading } = useProjects({ teamID });

  if (isLoading) {
    return (
      <PageContainer>
        <SpinnerCenter />
      </PageContainer>
    );
  }

  const mappedProjects = data?.projects.map((project) => ({
    ...project,
    uploadedAt: project.updatedAt,
    title: project.name,
  }));

  return (
    <OverlayProvider>
      <PageContainer title={t(m.General.SharedWithMe)}>
        <ProjectList
          projects={mappedProjects ?? []}
          users={data?.users ?? []}
          telemetryLocation="shared_with_me"
        />
        <WelcomeModal />
      </PageContainer>
    </OverlayProvider>
  );
};
